<template>
  <div class="content-box">
    <!-- 로그인한 사용자정보 영역 -->
    <HconMyPageUsrInfo />
    <div class="sub-wrapper">
      <!-- 마이페이지 사이드 메뉴 -->
      <HconMyPageSideMenu />

      <div class="sub-contents">
        <div class="border-title title">
          <h4 class="title">적립금 관리<span class="desc">적립금 이용내역을 조회하실 수 있습니다.</span></h4>
        </div>
        <div class="box-gray mt28 search">
          <fieldset class="search-form-wrap">
            <legend>적립금 관리 검색 폼</legend>
            <div class="search-form">
              <div class="form-box">
                <div class="form-group row">
                  <HconMonthDate label="조회기간" v-model="qryDates"/>
                </div>
              </div>
              <div class="form-box">
                <div class="form-group row">
                  <HconDropDown type="dropdownBox" v-model="inputValues.qryPntTrdTypDivCd" :dropdown-options="dropDownPntTrdTypCd" label="거래유형" :hide-label="false" defaultLabel="거래유형" selectBoxTitleClass="w300" />
                  <HconInput type="text" v-model="inputValues.qrySrchValue"  label="검색어" labelClass="ml20" placeholder="거래번호/거래명을 입력해주세요." />
                </div>
              </div>
            </div>
            <div class="btn-box">
              <button type="button" class="btn lg" @click="clickSearchButton">조회</button>
            </div>
          </fieldset>
        </div>
        <div class="contents-title-wrap mt40 button">
          <div class="contents-title">
            <h4 class="font-bold">총 <span class="text-green"> {{ totalData }} </span>건
              <span class="font-normal text-gray">(거래유형 '거래 대기' 상태의 경우 검색 시에만 내역 확인 가능합니다.)</span></h4>
          </div>
          <div class="rgt-area">
            <HconComPCExcelExport api="/api/v1/mypage/mileage/list/excel" :query="searchParams">
              <button type="button" class="btn btn-outline" :disabled="cu.isEmpty(mileageList)">엑셀다운로드</button>
            </HconComPCExcelExport>    
            <HconDropDown type="dropdownBox" :dropdownOptions="dropDownRowPerPage" selectBoxTitleClass="counter ml8" v-model="stringRowPerPage" />
          </div>
        </div>
        <div class="contents-detail-wrap">
          <table class="tbl-type">
            <caption>최근 적립금 사용 및 적립 내역</caption>
            <colgroup>
              <col style="width: 21%;">
              <col style="width: 9%;">
              <col style="width: auto;">
              <col style="width: 20%;">
            </colgroup>
            <thead>
              <tr>
                <th scope="col">거래번호/거래일시</th>
                <th scope="col">거래유형</th>
                <th scope="col">거래명/비고</th>
                <th scope="col" class="right pr32">적립금</th>
              </tr>
            </thead>
            <tbody v-if="mileageList.length > 0">
              <tr v-for="(mileage, index) in mileageList" :key="index">
                <td class="small">
                  <p class="title02 mb8">{{ mileage.pntApvNo }}</p>
                  <p class="desc01">{{ HconCommonUtils.format.dateTimeNoSec(mileage.pntDtm) }}</p>
                </td>
                <td class="small">{{ mileage.hcPntTrdTypCdNm }}</td>
                <td class="small left pl32 font-bold">{{ mileage.pntTrdCntn.split('|')[0] }}</td>
                <td class="small right pr32">
                  <strong class="font-bold" :class="(mileage.hcPntTrdTypCd === '1001' && mileage.hcPntTrdDivCd === '1002') || (mileage.hcPntTrdTypCd === '1003' && mileage.hcPntTrdDivCd === '1002' )|| mileage.hcPntTrdTypCd === '1003' ? 'text-red' : 'text-green'">
                    <span v-if="(mileage.hcPntTrdTypCd === '1001' && mileage.hcPntTrdDivCd === '1002') || (mileage.hcPntTrdTypCd === '1003' && mileage.hcPntTrdDivCd === '1002')|| mileage.hcPntTrdTypCd === '1003'">-</span>{{ mileage.trdAmt.toLocaleString() }}
                  </strong>원
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="4" class="nodata">적립금 내역이 없습니다.</td>
              </tr>
            </tbody>
          </table>
          <HconPagination :max-page="totalPage" :current-page="currentPage" @update:currentPage="handlePagination" />
        </div>
      </div>
  </div> 
      
  </div>
</template>
<script lang="ts" setup>
import { ref } from 'vue';
import { useRoute } from 'vue-router';
import HconInput from '@/components/com/HconComPCInputField.vue'
import HconDropDown from '@/components/com/HconComPCDropDown.vue'
import HconPagination from '@/components/com/HconComPCPagination.vue'
import HconMonthDate from '@/components/com/HconComPCDateButton.vue'
import { usePopup } from '@/composables/hconUsePopup'
import HconComPCExcelExport from "@/components/com/HconComPCExcelExport.vue";

// 마이페이지 메뉴
import HconMyPageSideMenu from '@/components/corner/pc/HconCornerMypageSideMenuPC.vue';
// 마이페이지 화면 상단의 사용자정보 영역
import HconMyPageUsrInfo from '@/components/corner/pc/HconCornerUserInfoPC.vue';
import type { CodeDto } from '~/types/common/backend-dto-types';
// DTO 준비
import type { MileageInfoDto } from '~/types/mileage/backend-dto-types';

const route = useRoute();
const qryDates = ref<[Date, Date] | null>(null);
const selectedPntTrdTypCd = ref("");
// 팝업 준비
const { showAlert, showConfirm } = usePopup()
const fetchBuilder        = useHconFetchBuilder();
const { refreshCnt, commonInfo } = useHeader();

const inputValues = ref({
    userKey: '' 
  , pageNum: ''
  , pageSize: '' // 조회쿠폰발송시점코드
  , qryStrtDt: '' // 조회주문상태코드
  , qryEndDt: '' // 조회키 [ordNo, ordNm, gdsNm, rcvrTelNo]
  , qrySrchValue: ''
  , qryPntTrdTypDivCd: ''
  , qryPntTrdTypCd: ''
  , qryPntTrdDivCd: ''
});
// 조회조건 읽기전용 매핑대상 준비
const searchParams = computed(() => {
  const qryStartDate = qryDates.value? HconCommonUtils.format.date(qryDates.value[0],'YYYYMMDD') : '';
  const qryEndDate = qryDates.value? HconCommonUtils.format.date(qryDates.value[1],'YYYYMMDD') : '';
  const qryPntTrdTypDivCd = inputValues.value.qryPntTrdTypDivCd;
  const qryPntTrdTypCd = ref('');
  const qryPntTrdDivCd = ref('');

  if(qryPntTrdTypDivCd == '10011') {
    qryPntTrdTypCd.value = '1001'
    qryPntTrdDivCd.value = '1001'
  } else if (qryPntTrdTypDivCd == '10012') {
    qryPntTrdTypCd.value = '1001'
    qryPntTrdDivCd.value = '1002'
  } else if (qryPntTrdTypDivCd == '10031') {
    qryPntTrdTypCd.value = '1003'
    qryPntTrdDivCd.value = '1001'
  } else if (qryPntTrdTypDivCd == '10032') {
    qryPntTrdTypCd.value = '1003'
    qryPntTrdDivCd.value = '1002'
  } else if (qryPntTrdTypDivCd == '10070') {
    qryPntTrdTypCd.value = '1007'
  }

  return {
    ...inputValues.value
    , qryStrtDt: qryStartDate // 조회시작일자
    , qryEndDt: qryEndDate // 조회종료일자
    , pageNum: currentPage.value
    , pageSize: rowPerPage.value
    , qryPntTrdTypCd: qryPntTrdTypCd.value
    , qryPntTrdDivCd: qryPntTrdDivCd.value
    , qrySrchValue: inputValues.value.qrySrchValue
  }
})
onMounted(async () => {
  refreshCnt();
  getMileageList();
  // fetchBuilder.get<AjaxResult<{hc_pnt_trd_typ_cd : CodeDto[] }>>('/api/v1/common/codes/hc_pnt_trd_typ_cd')
  // .build().execute()
  // .then((result) => {

  //   const hcPnttrdTypCdDataList = result.data.hc_pnt_trd_typ_cd.map( item => {
  //     return {
  //       key   : item.commDtlCd,
  //       value : item.commDtlCdNm,
  //     }
  //   });

  //   hcPntTrdTypCdList.splice(0,hcPntTrdTypCdList.length, ...hcPnttrdTypCdDataList);
  //   hcPntTrdTypCdList.unshift({key : '', value : '전체'})
  //   dropDownPntTrdTypCd.value = ''
  // });
})

//마이페이지 주문내역 목록 매핑대상 준비
const mileageList = ref<MileageInfoDto[]>([]);
//////////////////////////////////////////////
//       목록조회 시 페이징 처리 관련 모음
//////////////////////////////////////////////
/**
 * 1. 아래의 변수 4종과 함수 2종 선언
 * 2. 페이지네이션 컴포넌트는 HconComPCPagination.vue 사용
 * 3. API호출 시 아래 2종 반영
      3.1. .query 부분, pageNum & pageSize도 쿼리스트링에 포함 필요
      3.2. .then 부분, 총건수 세팅 필요
                       ex) ((result) => {
                             totalData.value = result.total || 0;
                           })
 * 4. 서비스(hcon-fo-api)에서는 아래 2종 반영
      4.1. requestDto에 int pageNum; & int pageSize; 추가
      4.2. controller에서 startPage(); 추가
 **/
// 1. 페이지네이션 매핑대상 변수 준비
const currentPage = ref<number>(1);  // 페이징 번호
const rowPerPage  = ref<number>(20); // 페이징 건수
const totalData   = ref<number>(0);  // 총 데이터 건수
const totalPage = computed (() => {  // 총 페이지 건수(계산식)
  if(mileageList.value.length === 0) return 0;
  return Math.ceil(totalData.value / rowPerPage.value);
});

// 2. 페이지네이션 클릭이벤트 핸들링 함수
const handlePagination = (pageNum: number) => {
  // 2.1. 숫자 클릭 시, 현재페이지를 새값으로 바꾸고 API호출
  currentPage.value = pageNum; 
  getMileageList();
}

// 추가기능1: 건수변경 드롭다운이 있을 경우, v-model 연결 및 API 즉시호출
const stringRowPerPage = computed({
  get: () => String(rowPerPage.value),
  set: (newVal: string) => {
    rowPerPage.value = Number(newVal);
    if(typeof currentPage !== 'undefined') {
      currentPage.value = 1;
    }
    getMileageList();
  }
})

// 추가기능2: 조회조건에 따른 (재)조회버튼이 있을 경우, 1페이지로 재설정 필요
const clickSearchButton = () => {
  currentPage.value = 1;
  getMileageList();
}

const dropDownRowPerPage = [ // 페이징건수
    {key: '20', value: '20개씩 보기'}
  , {key: '40', value: '40개씩 보기'}
  , {key: '100', value: '100개씩 보기'}
];

const dropDownPntTrdTypCd = [ // 주문상태
    {key: '', value: '전체'}
  , {key: '10011', value: '적립'}
  , {key: '10012', value: '적립취소'}
  , {key: '10031', value: '사용'}
  // , {key: '10032', value: '사용취소'}
  , {key: '10070', value: '환급'}
];

const getMileageList = () => {
fetchBuilder.get<TableDataInfo<MileageInfoDto>>('/api/v1/mypage/mileage/list')
      .query(searchParams.value)
      .build().execute()
  .then((result) => {
          // ref 형식 변수에 값 즉시 세팅
          mileageList.value = result.data || [];
          // 페이지네이션 처리
          totalData.value = result.total || 0;
    });
  }
</script>
<style lang="scss" scoped>
@use "@/assets/scss/pc/order-hcon.scss" as *;
@use "@/assets/scss/pc/mypage-hcon.scss" as *;

</style>